import { connect } from "react-redux";
import * as React from "react";
import { Layout, Menu, Dropdown, Icon, notification, BackTop } from "antd";
// import { connect } from "react-redux";
//import "./styles/layout.sass";
import Routes from "./routes";
import { gio } from "./gio";
// 快捷键插件
import Hotkeys from "react-hot-keys";
// 系统菜单
import SysMenu from "containers/SysMenu";
import { withRouter, RouteProps } from "react-router-dom";
import noticeEnhance from "widget/noticeEnhance";
import Log from "widget/detailFrom/log";

// 获取地址栏参数
import { getSearchVal } from "utils/tool";

// 判断是否需要禁用hotkey
import isDisabledHotkey from "utils/isDisabledHotkey";

// 工具库：判断是否包含属性并返回原值或默认值
import { getPropertysValues } from "utils/tool";

// 地址相关的功能  接口地址，websocket地址
import {
  getWebSocketAddr,
  EUrl,
  transformUrl,
  getUrlHead,
  getGoogleMapAddr,
  getMWAddr,
  getXBNAddr,
  getKCAddr,
  getHotelSearchAddr,
  getYYAddr,
  getYYAddrNew,
  getKCAddrNew,
} from "utils/enum/url";

// import Cookies from "js-cookie";

import "styles/global.scss";
// 系统菜单样式
import "styles/sysMenu.scss";
import { PositionProperty } from "csstype";
//import { FlexDirectionProperty } from "csstype";
// 消息面板
import NoticePanel from "containers/NoticePanel";
const { Header, Content, Sider } = Layout;

interface IApp {
  match: any;
  location: any;
  history: any;
  updateHotKey: any;
  loading: any;
  hotkey: any;
  // 获取用户信息
  getUser: any;
  // 用户信息相关
  userInfo: any;
  // 登出系统
  logout: any;
  // 更新系统状态
  updateSysMenuStatus: any;
  // 更新SharedWorker对象
  updateWS: any;
  // 添加消息
  addNotice: any;
  // 使消息面板滚动回顶部
  scrolToNoticePanelTop: any;
  // 是否显示消息管理
  isShowNotice: any;
  // 更新控制消息管理是否显示的方法
  updateIsShowNotice: any;
  // 获取消息模块中，未读消息的数目
  getUnReadCount: any;
  // 获取消息模块中，未读消息的数目 带条件
  getUnReadCountWithParams: any;
  // 未读消息统计
  unReadCount: any;
  // redux数据
  reduxData: any;
}

const menuStyle = {
  position: "absolute" as PositionProperty,
  // top: "45px",
  left: 0,
  width: "230px",
  zIndex: 100,
  overflow: "auto",
  height: "100%" // "calc( 100% - 45px)"
  // transition: "width 0.5s"
  // animation: "menu 0.2s"
};

const sysMenuStyle = {
  ...menuStyle,
  width: "46px"
  // position: "absolute" as PositionProperty,
  // zIndex: 100,
  // animation: "collapsed-menu 0.1s"
};
const smallSiderProps = {
  collapsedWidth: "46px",
  collapsed: true
};

class App extends React.Component<IApp & RouteProps, any> {
  state = {
    collapsed: true,
    visible: false,
    siderClass: "sider",
    style: sysMenuStyle,
    siderProps: smallSiderProps
  };

  // 临时方案标志
  isTemporary = true;

  menuData = [
  ];

  constructor(props: IApp) {
    super(props);

    this.onKeyDown = this.onKeyDown.bind(this)
    this.onKeyUp = this.onKeyUp.bind(this)
    var onConnect = function () {
      console.log("connected!");
    };

    var onDisConnect = function () {
      console.log("disconnect!");
    };

    // const token = Cookies.get("isg");
    ////debugger;
    var ws = gio(getWebSocketAddr(), onConnect, onDisConnect);
    ws.setWorker("/sharedWorker.js");

    ws.registerEvent("message", data => {
      //      this.props["updateOrder"](data);
      console.log("收到的消息", data);
      noticeEnhance.handleNotice(
        data,
        this.props.addNotice,
        mid => {
          ws.postMessage(mid, "syncCloseNotice");
        },
        () => {
          this.props.getUnReadCount();
          const noticePanel = "noticePanel";
          const reduxData = this.props.reduxData[noticePanel];
          const { beginDate, endDate, keys } = getPropertysValues(
            reduxData || [],
            ["beginDate", "endDate", "keys"]
          );
          // 查询消息面板中的未读统计
          this.props.getUnReadCountWithParams({
            search: keys,
            start: beginDate,
            end: endDate
          });
        }
      );
    });

    ws.registerEvent("syncCloseNotice", data => {
      console.log("syncCloseNotice", data);
      try {
        const id = JSON.parse(data).id;
        notification.close(id);
      } catch (error) {
        console.error(error);
      }
    });

    ws.onError(function (data) {
      console.log("error", data);
    });

    ws.start();
    this.props.updateWS(ws);
  }

  componentDidMount() {
    // 获取用户信息
    this.props.getUser();
    // 获取选中状态
    console.log("mkey", getSearchVal(this.props.location.search, "mkey"));
    let mkey: any = getSearchVal(this.props.location.search, "mkey");
    let openKey: any = getSearchVal(this.props.location.search, "openKey");

    // if (this.isTemporary) {
    // } else {
    if (!mkey || !openKey) {
      mkey = "2";
      openKey = "1";
    }

    this.props.updateSysMenuStatus({
      selectedKeys: mkey,
      openKeys: [openKey]
    });
    // }
  }

  toggle = () => {
    this.setState({
      //  collapsed: !this.state.collapsed
      visible: !this.state.visible
    });
  };

  // 设置顶部菜单
  settHeaderMenu = () => {
    const menuData: any = [
      {
        title: "Google地图",
        icon: "action-dingwei",
        url: getGoogleMapAddr
      },
      {
        title: "满位通知",
        icon: "action-zhuyi",
        url: getMWAddr
      },
      {
        title: " 仙本那房态查询",
        icon: "action-sousuo",
        url: getXBNAddr
      },
      {
        title: "库存查位",
        icon: "action-sousuo",
        url: getKCAddr
      },
      {
        title: "库存查位（新）",
        icon: "action-sousuo",
        url: getKCAddrNew
      },
      {
        title: "酒店接送和区域查询",
        icon: "action-sousuo",
        url: getHotelSearchAddr
      },
      {
        title: "运营后台",
        icon: "action-khjl",
        url: getYYAddr
      },
      {
        title: "新运营后台",
        icon: "action-khjl",
        url: getYYAddrNew
      },
    ];

    let menus: any = [];

    menuData.forEach((item, index) => {
      menus.push(
        <li key={index}>
          <a href={item.url} style={{ color: "#d9d9d9" }} target="_blank">
            <i className={"action-user " + item.icon} />
            {item.title}
          </a>
        </li>
      );
    });
    const dashboard = (
      <li key={"dashboard"}>
        <a href={"dashboard"} style={{ color: "#d9d9d9" }} target="_blank">
          <Icon type="dashboard" />
          工作台
        </a>
      </li>
    )
    menus.unshift(dashboard)
    return menus;
  };

  // 按键按下
  onKeyDown = (keyName, e, handle) => {
    // console.log("test:onKeyDown", keyName, e, handle);
    // 如果是暂停当次事件不执行
    if (this.props.hotkey[keyName]["suspend"]) {
      return;
    } else if (isDisabledHotkey(e.target)) {
      return;
    } else {
      this.props.updateHotKey({
        hotkey: keyName,
        activity: true
      });
    }
  };

  // 按键按下
  onKeyUp = (keyName, e, handle) => {
    // console.log("test:onKeyUp", e, handle);
    this.props.updateHotKey({
      hotkey: keyName,
      activity: false
    });
  };

  // 注册快捷键
  registerHotkey = () => {
    let hotkeys: any = [];
    for (const item in this.props.hotkey) {
      hotkeys.push(item);
    }
    return hotkeys.join();
  };

  // 关闭菜单
  onClose = () => {
    this.setState({
      visible: false
    });
  };

  // 登出系统
  logout = () => {
    this.props.logout({
      callback: (loginAddr: any) => {
        ////debugger;
        if (loginAddr) {
          window.location.href = getUrlHead() + loginAddr;
        }
      }
    });
  };

  // 收缩或展开菜单
  collapsed = () => {
    const collapsed = !this.state.collapsed;
    // console.log("collapsed", collapsed);
    if (collapsed) {
      this.setState({
        style: {
          ...menuStyle,
          width: 46
        },
        siderClass: "sider",
        siderProps: smallSiderProps,
        collapsed
      });
    } else {
      this.setState({
        style: menuStyle,
        siderClass: "",
        siderProps: {
          collapsed: false
        },
        collapsed
      });
    }
  };

  menu = (
    <Menu>
      <Menu.Item>
        <a
          className="user-menu"
          rel="修改密码"
          href={transformUrl(EUrl.updPwd)}
        >
          <i className="action-user action-suo" />
          <span style={{ marginLeft: 4 }}>修改密码</span>
        </a>
      </Menu.Item>
      <Menu.Item>
        <a
          className="user-menu"
          rel="登出"
          onClick={this.logout}
        >
          <i className="action-user action-yaoshi" />
          <span style={{ marginLeft: 4 }}>登出</span>
        </a>
      </Menu.Item>
    </Menu>
  );

  // 获取内容区域的对象
  getContentTarget = () => {
    const target: any = document.querySelector(".page-content");
    return target || window;
  };

  // 渲染消息管理
  renderNoticePanel = () => {
    if (this.props.isShowNotice) {
      const style = { flex: "0 0 303px", backgroundColor: "#F7F8FA" };
      return (
        <div style={style}>
          <NoticePanel />
        </div>
      );
    }
    return [];
  };

  render() {
    const contentStyle = {
      // margin: "24px 16px",

      padding: 24,
      background: "#eee"
      //minHeight: 800
    };

    const menuLinkStyle = {
      display: "inline-block",
      lineHeight: "45px"
    };

    const menuIConStyle = {
      fontSize: "20px",
      lineHeight: "45px",
      marginLeft: "15px"
    };

    // { width: "46px" }

    // const footerStyle = {
    //   display: "flex",
    //   alignItems: "center",
    //   flexDirection: "column" as FlexDirectionProperty,
    //   padding: "10px 50px"
    // };

    //菜单图标
    /* <Icon
                className="trigger"
                type={this.state.visible ? "menu-fold" : "menu-unfold"}
                onClick={this.toggle}
              /> */
    // console.log("collapsed变化了", this.state.collapsed);
    // console.log("collapsed变化了", this.state.style);

    // 消息样式
    const msgStyle: any = {};
    if (this.props.isShowNotice) {
      msgStyle.color = "red";
    }

    // 显示消息数目
    const showTipNum = () => {
      return this.props.unReadCount ? (
        <span className="tip">{this.props.unReadCount}</span>
      ) : (
          []
        );
    };

    return (
      <Hotkeys
        keyName={this.registerHotkey()}
        onKeyDown={this.onKeyDown}
        onKeyUp={this.onKeyUp}
      >
        <React.Fragment>
          <Layout>
            <Header
              className="main-header"
              style={{ background: "#000", padding: 0, height: "45px" }}
            >
              <a
                style={menuLinkStyle}
                onClick={this.collapsed}
              >
                <Icon type="bars" style={menuIConStyle} />
              </a>
              <div className="logo" />
              <div>
                <ul>{this.settHeaderMenu()}</ul>
              </div>
              <div className="main-tool">
                <Dropdown overlay={this.menu} trigger={["click"]}>
                  <a>
                    <span style={{ marginRight: 4 }}>
                      {this.props.userInfo.name}
                    </span>
                    <i className="action-user action-xia" />
                  </a>
                </Dropdown>
                ,
                <a
                  className="notice__showNum"
                  style={msgStyle}
                  onClick={this.props.updateIsShowNotice}
                >
                  {showTipNum()}
                  <i className="action-user action-xiaoxi" />
                </a>
                <Log />
              </div>

            </Header>
            <Layout>
              <Sider
                className={this.state.siderClass}
                collapsible={true}
                collapsed={true}
                defaultCollapsed={true}
                width={46}
                {...this.state.siderProps}
              >
                <SysMenu
                  collapsed={this.state.collapsed}
                  menuData={this.menuData}
                  style={this.state.style}
                  isTemporary={this.isTemporary}
                />
              </Sider>
              <Content className="page-content" style={contentStyle}>
                <Routes />
                {/* 回到顶部 */}
                <BackTop target={this.getContentTarget} />
              </Content>
              {/* 消息管理 */}
              {this.renderNoticePanel()}
            </Layout>
          </Layout>

        </React.Fragment>
      </Hotkeys>
    );
  }
}

{
  /* <div style={{ flex: "0 0 260px", backgroundColor: "#F7F8FA" }}>
<NoticePanel />
</div> */
}

{
  /* 版权
            <Footer style={footerStyle}>
              <div>懒猫旅行，随走随订</div>
              <div>
                Copyright © lanmao.cn
                湖南懒猫国际旅行社有限公司湘ICP备13011950号-2 湘B2-20150066
              </div>
            </Footer> */
}

const mapState = state => ({
  hotkey: state.hotkey,
  loading: state.globalStatus.loading,
  userInfo: state.userInfo.user,
  // 是否显示消息
  isShowNotice: state.noticeMg.isShowNotice,
  // 未读消息统计
  unReadCount: state.noticeMg.unReadCount,
  reduxData: state.antDemo
});

const mapDispatch = dispatch => {
  const noticeMg = dispatch.noticeMg;
  return {
    // 更新热键的信息
    updateHotKey: dispatch.hotkey.updateHotKey,
    // 获取用户信息
    getUser: dispatch.userInfo.getUser,
    // 登出系统
    logout: dispatch.userInfo.logout,
    // 更新系统菜单状态
    updateSysMenuStatus: dispatch.globalStatus.updateSysMenuStatus,
    // 更新sharedWorker对象
    updateWS: noticeMg.updateWS,
    // 把消息添加到 全部栏下的消息面板中
    addNotice: noticeMg.addNotice,
    // 滚动条消息面板顶部
    scrolToNoticePanelTop: noticeMg.scrolToNoticePanelTop,
    // 更新是否显示消息管理的值
    updateIsShowNotice: noticeMg.updateIsShowNotice,
    // 获取未读消息数目
    getUnReadCount: noticeMg.getUnReadCount,
    // 获取未读消息数目 带条件
    getUnReadCountWithParams: noticeMg.getUnReadCountWithParams
  };
};
//console.log(mapState);
//console.log(mapDispatch);
export default withRouter(connect(
  mapState,
  mapDispatch
)(App));
